import { lineLoginConfig, environment } from "../../config/environment"
const queryString = require('query-string');
const redirectUri = window.location.origin + window.location.pathname

export default class lineAuth {
	constructor(cookies, location, getUserInfo){
    this.cookies = cookies
    this.location = location
    this.getUserInfo = getUserInfo
    this.params = queryString.parse(location.search)
    this.init()
	}

  async init(){
    if(!this.cookies.get("lineId")){
      if(this.params.state !== "authorized") {
        this.lineAuthorization()
      }
      else{
        const result = await this.decodeLineId(this.params.code, redirectUri)
        const lineId = result.message
        if(this.isValidLineId(lineId)){
          this.cookies.set("lineId", lineId)
          this.getUserInfo(lineId)
        }else{
          this.catchLineIdFail()
        }
      }
    }
    else{
      const lineId = this.cookies.get("lineId")
      if(this.isValidLineId(lineId)){
        this.getUserInfo(lineId)
      }else{
        this.catchLineIdFail()
      }
    }
  }

  async decodeLineId(lineCode, redirectUri) {
    return new Promise((resolve, reject) => {
      return fetch(environment.modelServiceUrl + "/lineAuth/app", {
        headers: {
          "Content-Type": "application/json"
        },
        method: 'POST',
        body: JSON.stringify({
          code: lineCode,
          redirectUri: redirectUri,
        })
      })
      .then(response => response.json())
      .then(responseJson => {
        resolve(responseJson)
      })
    })
  }

  lineAuthorization(){
    var url = 'https://access.line.me/oauth2/v2.1/authorize?';
    url += 'response_type=code';
    url += `&client_id=${lineLoginConfig.client_id}`;
    url += `&redirect_uri=${redirectUri}`;
    url += `&state=authorized`;
    url += '&scope=openid%20profile';
    window.location.href = url;
  }

  isValidLineId(lineId){
    const regexp = new RegExp('^U[0-9a-f]{32}$')
    return regexp.test(lineId)
  }

  catchLineIdFail(){
    this.cookies.remove("lineId")
    alert("LINE 系統授權失敗，即將幫你排除💪")
    window.location.href = redirectUri
  }

}